import { PropsWithChildren } from 'react';

interface IIsVisibleProps {
  when: boolean;
}

export function IsVisible({
  children,
  when,
}: PropsWithChildren<IIsVisibleProps>) {
  if (!when) {
    return null;
  }

  return children;
}
